import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CommissionPromotionsService } from 'src/app/services/commission-promotions.service';
import Swal from "sweetalert2";

@Component({
  selector: "app-modal-new-promotion-v2",
  templateUrl: "./modal-new-promotion-v2.component.html",
  styleUrls: ["./modal-new-promotion-v2.component.css"],
})
export class ModalNewPromotionV2Component implements OnInit {
  @Input() mode: string;
  @Input() selectedFieldIds: number[] = [];
  @Input() nombrePadre: string;
  @Output() fieldsSelected = new EventEmitter<any[]>();
  @Output() closed = new EventEmitter<string>();

  now = new Date();
  promotionFields: CatalogModel[] = [];
  promotionFieldsActive: number[] = [];
  public viewStatus = 1;

  constructor(
    private commissionPromotionsService: CommissionPromotionsService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    console.log("Modo del modal v2:", this.mode);
    console.log("Nombre del padre:", this.nombrePadre);
    this.getCatalogs();
  }

  onCheck(fieldId: number) {
    const idx = this.promotionFieldsActive.indexOf(fieldId);
    if (idx === -1) {
      this.promotionFieldsActive.push(fieldId);
      if (fieldId == 20) {
        Swal.fire(
          "CUIDADO",
          "Las configuraciones que incluyen el campo de Clave Promoción tienen prioridad sobre las demás. Úselo con precaución.",
          "warning"
        );
      }
    } else {
      this.promotionFieldsActive.splice(idx, 1);
    }
  }

  isChecked(fieldId: number): boolean {
    return this.promotionFieldsActive.indexOf(fieldId) !== -1;
  }

  confirm() {
    if (this.promotionFieldsActive.length === 0) {
      this.toastr.warning('Selecciona al menos un campo');
      return;
    }

    const userId = parseInt(localStorage.getItem('com_token'), 10) || 0;
    const camposSeleccionados = this.promotionFields
      .filter(f => this.promotionFieldsActive.indexOf(f.id) !== -1)
      .map(f => ({
        campoId: f.id,
        nombreCampo: f.description,
        activoId: 1,
        usuarioId: userId,
        fechaCreacion: null,
      }));

    this.fieldsSelected.emit(camposSeleccionados);
    this.closed.emit('confirm');
  }

  close(reason: string) {
    this.closed.emit(reason);
  }

  getCatalogs = () => {
    this.commissionPromotionsService.getCatalogPromotionFields().subscribe(
      (response: any) => {
        this.promotionFields = response;

        // Agregar campo 23: Sub-producto si no viene del backend
        const hasSubProduct = this.promotionFields.some(f => f.id === 23);
        if (!hasSubProduct) {
          this.promotionFields.push({
            id: 23,
            description: 'Sub-producto',
            activeId: true
          } as CatalogModel);
        }

        // Pre-seleccionar campos si vienen del padre (modo edición)
        if (this.selectedFieldIds && this.selectedFieldIds.length > 0) {
          this.promotionFieldsActive = [...this.selectedFieldIds];
        }

        // Filtrar campos 20 y 22 en modo meta
        if (this.nombrePadre === "meta") {
          this.promotionFields = this.promotionFields.filter(f => f.id !== 20 && f.id !== 22);
        }

        this.viewStatus = 1;
      },
      (error) => {
        this.viewStatus = -1;
        this.toastr.error("Error al obtener los campos disponibles");
        console.error(error);
        this.close("error");
      }
    );
  }
}
